module.exports = __webpack_public_path__ + "media/img/logo-8d1bafca57f420bde0050db55adc2d0e.svg";